import React, { useState } from "react";
import { Button, Checkbox, DatePicker, Form, Image, Input, Layout, message, notification, Radio, Select, Typography } from "antd";
import HeaderComponent from "../component/header";
import { API_URL } from "../constant";
import { CheckOutlined } from "@ant-design/icons";

const { Option } = Select;
const { Title } = Typography;
const { Link } = Typography;
const { Header } = Layout;

const FullRenewalPage: React.FC = () => {
  const [form] = Form.useForm();


  const onSubmit = () => {
    console.log("Form submitted");  
  };

  const onFinishFailed = (errorInfo: any) => {
    alert("Please check the form fields and try again.");
  };

  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = `${API_URL}online-quotation-inquiry/images/renewalshort.pdf`;
    link.download = "filename.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div>
      <HeaderComponent />
      <div className='mt-10 max-w-screen-xl mx-auto p-20'>

        <div className='flex flex-col mb-10'>
          <Title level={2} className="flex justify-center">CHIROPRACTIC PROFESSIONAL LIABILITY RENEWAL APPLICATION</Title>
        </div>

        <Form
          form={form}
          layout="horizontal"
          onFinish={onSubmit}
          onFinishFailed={onFinishFailed}
        >
            <div className='mb-5 grid grid-cols-2 sm:grid-cols-6 gap-2'>
                <div className='col-span-2 sm:col-span-6'>
                    <Title level={5}>I. PERSONAL INFORMATION</Title>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-4'>
                    <Form.Item label="Name" name="name" rules={[{ required: true }]}>
                        <Input placeholder="Please enter your Name" />
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-2'>
                    <Form.Item label="Date of Birth:" name="date_of_birth" rules={[{ required: true }]}>
                        <DatePicker placeholder="Please enter Date" style={{ width: "100%" }} />
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-4'>
                    <Form.Item label="Practice address" name="practice_address" rules={[{ required: true }]}>
                        <Input placeholder="Please enter your Practice address" />
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-2'>
                    <Form.Item label="Country" name="country" rules={[{ required: true }]}>
                        <Input placeholder="Please enter your Country" />
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-6'>
                    <Form.Item label="Additional Practice Locations, if any. If “none” please indicate:" name="additional_practice_locations" rules={[{ required: true }]}>
                        <Input placeholder="Please enter your Additional Practice Locations" />
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-6'>
                    <Form.Item label="Mailing Address: " name="mailing_address" rules={[{ required: true }]}>
                        <Input placeholder="Please enter your Mailing Address" />
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-6'>
                    <Form.Item label="Home Address: " name="home_address" rules={[{ required: true }]}>
                        <Input placeholder="Please enter your Home Address" />
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-2 lg:col-span-2'>
                    <Form.Item label="Office Phone" name="office_phone" rules={[{ required: true }, { pattern: /^\d{3}-\d{3}-\d{4}$/, message: 'Use XXX-XXX-XXXX format please' }]}>
                        <Input placeholder="Please enter your Office Phone" />
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-2 lg:col-span-2'>
                    <Form.Item label="Home or Cell Phone:" name="cell_phone" rules={[{ required: true }, { pattern: /^\d{3}-\d{3}-\d{4}$/, message: 'Use XXX-XXX-XXXX format please' }]}>
                        <Input placeholder="Please enter your Home or Cell Phone" />
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-2 lg:col-span-2'>
                    <Form.Item label="Fax" name="fax" rules={[{ required: true }, { pattern: /^\d{3}-\d{3}-\d{4}$/, message: 'Use XXX-XXX-XXXX format please' }]}>
                        <Input placeholder="Please enter your Fax" />
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-3'>
                    <Form.Item label="Email:" name="email" rules={[{ required: true }]}>
                        <Input placeholder="Please enter your Email" />
                    </Form.Item>
                </div>
                 <div className='col-span-2 sm:col-span-6 lg:col-span-3'>
                    <Form.Item label="Secondary Email:" name="secondary_email" rules={[{ required: false }]}>
                        <Input placeholder="Please enter your Secondary Email" />
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-6'>
                    <Form.Item label="WebSite :" name="website" rules={[{ required: true }]}>
                        <Input placeholder="Please enter your WebSite" />
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-6'>
                    <Form.Item label="List Chiropractic Association Memberships :" name="list_memberships" rules={[{ required: true }]}>
                        <Input placeholder="Please enter your Chiropractic Association Memberships" />
                    </Form.Item>
                </div>
            </div>

            <div className='mb-5 grid grid-cols-2 sm:grid-cols-6 gap-2'>
                <div className='col-span-2 sm:col-span-6 lg:col-span-6'>
                    <Title level={5}>II. CURRENT PRACTICE INFORMATION</Title>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-6'>
                    <p>1. If you work as an employee or independent contractor, please provide
                            the name of the facility where you work and the name and professional
                            licensure and/or designation of owner:</p>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-6'>
                    <Form.Item 
                        name="facility_info" 
                        rules={[{ required: true }]} 
                    >
                        <Input placeholder="Please enter the facility info" />
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-6'>
                    <p>2. If you own your practice, please advise of the following:</p>
                </div>
                <div className='col-span-2 ml-4 sm:col-span-3 lg:col-span-3'>
                    <p>A.&nbsp;&nbsp;&nbsp;Business structure under which you practice:</p>
                </div>
                <div className='col-span-2 sm:col-span-1 lg:col-span-1'>
                    <Form.Item name="sole_proprietor" valuePropName="checked">
                        <Checkbox>Sole Proprietor</Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-2 lg:col-span-2'>
                    <Form.Item name="incorporated_pc_pa" valuePropName="checked">
                        <Checkbox>Incorporated, P.C. or P.A</Checkbox>
                    </Form.Item>
                </div>
                <div className='ml-4 col-span-2 sm:col-span-1 lg:col-span-1'>
                    <div className="flex flex-row">
                        <p className="mt-1 mr-4">B. </p>
                        <Form.Item name="llc_llp" valuePropName="checked">
                            <Checkbox>L.L.C. or L.L.P.</Checkbox>
                        </Form.Item>
                    </div>
                </div>
                <div className='col-span-2 sm:col-span-1 lg:col-span-1'>
                    <Form.Item name="partnership" valuePropName="checked">
                        <Checkbox>Partnership</Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-1 lg:col-span-1'>
                    <Form.Item name="other" valuePropName="checked">
                        <Checkbox>Other (Please specify) </Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-3 lg:col-span-3'>
                    <Form.Item name="other_specify" rules={[{ required: false }]}>
                        <Input/>
                    </Form.Item>
                </div>
            </div>
            <div className="grid grid-cols-[auto_1fr] gap-2">
                <span className="ml-4 mr-3 mt-2">C. </span>
                <div className="">
                    <Form.Item
                    label="Please provide the name of your legal entity (if any):"
                    name="legal_entity_name"
                    rules={[{ required: true }]}
                    >
                        <Input placeholder="Please enter the name of your legal entity" />
                    </Form.Item>
                </div>
            </div>
            <div className='mb-5 grid grid-cols-2 sm:grid-cols-6 gap-2'>
                <div className='ml-12 col-span-2 sm:col-span-6 lg:col-span-6'>
                    <Form.Item
                    label="FEIN or TAX ID number of the legal entity:"
                    name="legal_entity_tax_id"
                    rules={[{ required: true }]}
                    >
                        <Input placeholder="Please enter the FEIN or TAX ID number of your legal entity" />
                    </Form.Item>
                </div>
                <div className='ml-4 col-span-2 sm:col-span-6 lg:col-span-6'>
                    <p>D.&nbsp;&nbsp;&nbsp; Including yourself, name shareholders, owners, officers, partners, etc, their professional designation  and relationship:</p>
                </div>
                <div className='ml-12 col-span-2 sm:col-span-6 lg:col-span-6'>
                    <Form.Item name="relationship" rules={[{ required: true }]}>
                        <Input/>
                    </Form.Item>
                </div>
                <div className='ml-4 col-span-2 sm:col-span-6 lg:col-span-6'>
                    <p>E.&nbsp;&nbsp;&nbsp; Do you desire a shared or separate limit of liability to apply to your legal entity?</p>
                </div>
                <div className='ml-12 col-span-2 sm:col-span-6 lg:col-span-6'>
                    <Form.Item name="shared_liability" rules={[{ required: true }]}>
                        <Checkbox>Shared (limits are shared with you at no cost) </Checkbox>
                    </Form.Item>
                </div>
                <div className='ml-12 col-span-2 sm:col-span-6 lg:col-span-6'>
                    <Form.Item name="separate_liability" rules={[{ required: true }]}>
                        <Checkbox>Separate (subject to approval. Entity has its own set of limits and additional charge applies) </Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-6'>
                    <p>3. Besides yourself, indicate the number of all chiropractors who work in your office or with whom you share space:</p>
                </div>
                <div className='ml-12 col-span-2 sm:col-span-1 lg:col-span-1'>
                    <Form.Item  name="list_memberships" rules={[{ required: true }]}>
                        <Input/>
                    </Form.Item>
                </div>
                <div className='mt-1 col-span-2 sm:col-span-5 lg:col-span-5'>
                    <span>Attach a separate application or proof of professional liability for each individual</span>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-6'>
                    <p>4.  Please complete the table below and advise the number of health care professionals working in practice:</p>
                </div>
            </div>
            <div className="flex flex-col justify-center">
                <table style={{ border: "solid 1px black", width: "95%" }}>
                    <tr className="h-12" style={{ border: "solid 1px black"}}>
                        <td className ="mt-2 ml-6 text-center font-bold" style={{ border: "solid 1px black", width: "30%" }}>
                            Type
                        </td>
                        <td className ="mt-2 ml-6 text-center font-bold" style={{ border: "solid 1px black", width: "20%" }}>
                            # Employed
                        </td>
                        <td className ="mt-2 ml-6 text-center font-bold" style={{ border: "solid 1px black", width: "25%" }}>
                            # of Ind. Contractor
                        </td>
                        <td className ="mt-2 ml-6 text-center font-bold" style={{ border: "solid 1px black", width: "25%" }}>
                            # Sharing Space
                        </td>
                    </tr> 
                    <tr className="h-12" style={{ border: "solid 1px black"}}>
                        <td className ="pl-5" style={{ border: "solid 1px black", width: "30%" }}>
                            Chiropractor
                        </td>
                        <td className ="p-2" style={{ border: "solid 1px black", width: "20%" }}>
                            <Form.Item  className="mb-0" name="chiropractor_1" rules={[{ required: true }]}>
                                <Input/>
                            </Form.Item>
                        </td>
                        <td className ="p-2" style={{ border: "solid 1px black", width: "25%" }}>
                            <Form.Item  className="mb-0" name="chiropractor_2" rules={[{ required: true }]}>
                                <Input/>
                            </Form.Item>
                        </td>
                        <td className ="p-2" style={{ border: "solid 1px black", width: "25%" }}>
                            <Form.Item  className="mb-0" name="chiropractor_3" rules={[{ required: true }]}>
                                <Input/>
                            </Form.Item>
                        </td>
                    </tr> 
                    <tr className="h-12" style={{ border: "solid 1px black"}}>
                        <td className ="pl-5" style={{ border: "solid 1px black", width: "30%" }}>
                            Chiropractic Assistant
                        </td>
                        <td className ="p-2" style={{ border: "solid 1px black", width: "20%" }}>
                            <Form.Item  className="mb-0" name="chiropractic_assistant_1" rules={[{ required: true }]}>
                                <Input/>
                            </Form.Item>
                        </td>
                        <td className ="p-2" style={{ border: "solid 1px black", width: "25%" }}>
                            <Form.Item  className="mb-0" name="chiropractic_assistant_2" rules={[{ required: true }]}>
                                <Input/>
                            </Form.Item>
                        </td>
                        <td className ="p-2" style={{ border: "solid 1px black", width: "25%" }}>
                            <Form.Item  className="mb-0" name="chiropractic_assistant_3" rules={[{ required: true }]}>
                                <Input/>
                            </Form.Item>
                        </td>
                    </tr> 
                    <tr className="h-12" style={{ border: "solid 1px black"}}>
                        <td className ="pl-5" style={{ border: "solid 1px black", width: "30%" }}>
                            Massage Therapist
                        </td>
                        <td className ="p-2" style={{ border: "solid 1px black", width: "20%" }}>
                            <Form.Item  className="mb-0" name="massage_therapist_1" rules={[{ required: true }]}>
                                <Input/>
                            </Form.Item>
                        </td>
                        <td className ="p-2" style={{ border: "solid 1px black", width: "25%" }}>
                            <Form.Item  className="mb-0" name="massage_therapist_2" rules={[{ required: true }]}>
                                <Input/>
                            </Form.Item>
                        </td>
                        <td className ="p-2" style={{ border: "solid 1px black", width: "25%" }}>
                            <Form.Item  className="mb-0" name="massage_therapist_3" rules={[{ required: true }]}>
                                <Input/>
                            </Form.Item>
                        </td>
                    </tr> 
                    <tr className="h-12" style={{ border: "solid 1px black"}}>
                        <td className ="pl-5" style={{ border: "solid 1px black", width: "30%" }}>
                            Other (specify)
                        </td>
                        <td className ="p-2" style={{ border: "solid 1px black", width: "20%" }}>
                            <Form.Item  className="mb-0" name="other_1" rules={[{ required: true }]}>
                                <Input/>
                            </Form.Item>
                        </td>
                        <td className ="p-2" style={{ border: "solid 1px black", width: "25%" }}>
                            <Form.Item  className="mb-0" name="other_2" rules={[{ required: true }]}>
                                <Input/>
                            </Form.Item>
                        </td>
                        <td className ="p-2" style={{ border: "solid 1px black", width: "25%" }}>
                            <Form.Item  className="mb-0" name="other_3" rules={[{ required: true }]}>
                                <Input/>
                            </Form.Item>
                        </td>
                    </tr> 
                </table>
                <div className="flex mt-2 font-bold">
                    IMPORTANT: Attach proof of professional liability insurance (other than your C.A.) for all employees,Independent Contractors and shared space arrangements.
                </div>
            </div>

            <div className='mt-5 grid grid-cols-2 sm:grid-cols-6 gap-2'>
                <div className='col-span-2 sm:col-span-6 lg:col-span-6'>
                    <p>5.  How many total hours per week are you practicing (includes time spent treating patients, noting charts and consulting, i.e. IME, Utilization Review, and Peer Review)?</p>
                </div>
                <div className='ml-8 col-span-2 sm:col-span-3 lg:col-span-3'>
                    <Form.Item label="Total Hours Per Week" name="total_hours_per_week" rules={[{ required: true }]}>
                        <Input/>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-4 lg:col-span-4'>
                    <p>6. Have you attended a risk-management seminar in the last 24 months?</p>
                </div>
                <div className='col-span-2 sm:col-span-1 lg:col-span-1'>
                    <Form.Item name="risk_yes" valuePropName="checked">
                        <Checkbox>Yes</Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-1 lg:col-span-1'>
                    <Form.Item name="risk_no" valuePropName="checked">
                        <Checkbox>No</Checkbox>
                    </Form.Item>
                </div>
                <div className='ml-8 col-span-2 sm:col-span-3 lg:col-span-3'>
                    <Form.Item label="Presenter" name="presenter" rules={[{ required: true }]}>
                        <Input/>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-3 lg:col-span-3'>
                    <Form.Item label="Subject" name="subject" rules={[{ required: true }]}>
                        <Input/>
                    </Form.Item>
                </div>
                <div className='mt-16 col-span-2 sm:col-span-6'>
                    <Title level={5}>III. CLINICAL PRACTICE INFORMATION</Title>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-6'>
                    <p>1. &nbsp;&nbsp;Check each of the following items provided by you or someone employed by you in your practice .
                    If you order tests, but the actual procedure is referred out, please identify by checking the “RO” box
                    (Referred Out).</p>
                </div>
            </div>
            <div className='mt-5 grid grid-cols-2 sm:grid-cols-12 gap-2'>
                <div className="ml-10 col-span-2 sm:col-span-6 lg:col-span-6">
                    <div className="grid grid-cols-2 sm:grid-cols-6 gap-2 bg-gray-200">
                        <div className='ml-2 mt-2 col-span-2 sm:col-span-1 lg:col-span-1'>
                            <CheckOutlined/>
                        </div>
                        <div className='mt-2 col-span-2 sm:col-span-4 lg:col-span-4'>
                            Procedure
                        </div>
                         <div className='mt-2 col-span-2 sm:col-span-1 lg:col-span-1'>
                            Refer
                        </div>
                    </div>
                </div>
                <div className="ml-10 col-span-2 sm:col-span-6 lg:col-span-6">
                    <div className="grid grid-cols-2 sm:grid-cols-6 gap-2 bg-gray-200">
                        <div className='ml-2 mt-2 col-span-2 sm:col-span-1 lg:col-span-1'>
                            <CheckOutlined/>
                        </div>
                        <div className='mt-2 col-span-2 sm:col-span-4 lg:col-span-4'>
                            Procedure
                        </div>
                         <div className='mt-2 col-span-2 sm:col-span-1 lg:col-span-1'>
                            Refer
                        </div>
                    </div>
                </div>
                <div className='ml-10 col-span-2 sm:col-span-4 lg:col-span-5'>
                    <Form.Item name="adjustments_check">
                        <Checkbox>Adjustments </Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-2 lg:col-span-1'>
                    <Form.Item name="adjustments_ro">
                        <Checkbox>RO </Checkbox>
                    </Form.Item>
                </div>
                <div className='ml-10 col-span-2 sm:col-span-4 lg:col-span-5'>
                    <Form.Item name="hair_analysis_check">
                        <Checkbox>Hair Analysis </Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-2 lg:col-span-1'>
                    <Form.Item name="hair_analysis_ro">
                        <Checkbox>RO </Checkbox>
                    </Form.Item>
                </div>
                <div className='ml-10 col-span-2 sm:col-span-4 lg:col-span-5'>
                    <Form.Item name="cryotherapy_check">
                        <Checkbox>Cryotherapy </Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-2 lg:col-span-1'>
                    <Form.Item name="cryotherapy_ro">
                        <Checkbox>RO </Checkbox>
                    </Form.Item>
                </div>
                <div className='ml-10 col-span-2 sm:col-span-6 lg:col-span-6'>
                    <Form.Item name="treatment_diagnosis_check">
                        <Checkbox>Treatment or Diagnosis of Disease other than N.M.S. </Checkbox>
                    </Form.Item>
                </div>
                <div className='ml-10 col-span-2 sm:col-span-4 lg:col-span-5'>
                    <Form.Item name="litmus_paper_check">
                        <Checkbox>Litmus Paper (B.E.S.T.) </Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-2 lg:col-span-1'>
                    <Form.Item name="litmus_paper_ro">
                        <Checkbox>RO </Checkbox>
                    </Form.Item>
                </div>
                <div className='ml-10 col-span-2 sm:col-span-4 lg:col-span-5'>
                    <Form.Item name="foot_bath_check">
                        <Checkbox>Foot Bath </Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-2 lg:col-span-1'>
                    <Form.Item name="foot_bath_ro">
                        <Checkbox>RO </Checkbox>
                    </Form.Item>
                </div>
                <div className='ml-10 col-span-2 sm:col-span-4 lg:col-span-5'>
                    <Form.Item name="ultra_sound_check">
                        <Checkbox>Ultra Sound </Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-2 lg:col-span-1'>
                    <Form.Item name="ultra_sound_ro">
                        <Checkbox>RO </Checkbox>
                    </Form.Item>
                </div>
                <div className='ml-10 col-span-2 sm:col-span-4 lg:col-span-5'>
                    <Form.Item name="diagnostic_blood_check">
                        <Checkbox>Interpretation of Diagnostic Blood Studies </Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-2 lg:col-span-1'>
                    <Form.Item name="diagnostic_blood_ro">
                        <Checkbox>RO </Checkbox>
                    </Form.Item>
                </div>
                <div className='ml-10 col-span-2 sm:col-span-4 lg:col-span-5'>
                    <Form.Item name="auriculotherapy_check">
                        <Checkbox>Auriculotherapy </Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-2 lg:col-span-1'>
                    <Form.Item name="auriculotherapy_ro">
                        <Checkbox>RO </Checkbox>
                    </Form.Item>
                </div>
                <div className='ml-10 col-span-2 sm:col-span-4 lg:col-span-5'>
                    <Form.Item name="urinalysis_check">
                        <Checkbox>Urinalysis </Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-2 lg:col-span-1'>
                    <Form.Item name="urinalysis_ro">
                        <Checkbox>RO </Checkbox>
                    </Form.Item>
                </div>
                <div className='ml-10 col-span-2 sm:col-span-4 lg:col-span-5'>
                    <Form.Item name="mri_ct_scan_check">
                        <Checkbox>MRI/CT Scan </Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-2 lg:col-span-1'>
                    <Form.Item name="mri_ct_scan_ro">
                        <Checkbox>RO </Checkbox>
                    </Form.Item>
                </div>
                <div className='ml-10 col-span-2 sm:col-span-4 lg:col-span-5'>
                    <Form.Item name="homeopathy_check">
                        <Checkbox>Homeopathy</Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-2 lg:col-span-1'>
                    <Form.Item name="homeopathy_ro">
                        <Checkbox>RO </Checkbox>
                    </Form.Item>
                </div>
                <div className='ml-10 col-span-2 sm:col-span-4 lg:col-span-5'>
                    <Form.Item name="diathermy_check">
                        <Checkbox>Diathermy</Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-2 lg:col-span-1'>
                    <Form.Item name="diathermy_ro">
                        <Checkbox>RO </Checkbox>
                    </Form.Item>
                </div>
                <div className='ml-10 col-span-2 sm:col-span-4 lg:col-span-5'>
                    <Form.Item name="acupuncture_check">
                        <Checkbox>Acupuncture</Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-2 lg:col-span-1'>
                    <Form.Item name="acupuncture_ro">
                        <Checkbox>RO </Checkbox>
                    </Form.Item>
                </div>
                <div className='ml-10 col-span-2 sm:col-span-4 lg:col-span-5'>
                    <Form.Item name="galvanic_stimulation_check">
                        <Checkbox>Galvanic Stimulation</Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-2 lg:col-span-1'>
                    <Form.Item name="galvanic_stimulation_ro">
                        <Checkbox>RO </Checkbox>
                    </Form.Item>
                </div>
                <div className='ml-10 col-span-2 sm:col-span-4 lg:col-span-5'>
                    <Form.Item name="colon_irrigation_check">
                        <Checkbox>Colon Irrigation</Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-2 lg:col-span-1'>
                    <Form.Item name="colon_irrigation_ro">
                        <Checkbox>RO </Checkbox>
                    </Form.Item>
                </div>
                <div className='ml-10 col-span-2 sm:col-span-4 lg:col-span-5'>
                    <Form.Item name="interferrential_check">
                        <Checkbox>Interferrential</Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-2 lg:col-span-1'>
                    <Form.Item name="interferrential_ro">
                        <Checkbox>RO </Checkbox>
                    </Form.Item>
                </div>
                <div className='ml-10 col-span-2 sm:col-span-4 lg:col-span-5'>
                    <Form.Item name="drugs_prescribed_check">
                        <Checkbox>Drugs prescribed or injected</Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-2 lg:col-span-1'>
                    <Form.Item name="drugs_prescribed_ro">
                        <Checkbox>RO </Checkbox>
                    </Form.Item>
                </div>
                <div className='ml-10 col-span-2 sm:col-span-4 lg:col-span-5'>
                    <Form.Item name="microcurrent_check">
                        <Checkbox>Microcurrent</Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-2 lg:col-span-1'>
                    <Form.Item name="microcurrent_ro">
                        <Checkbox>RO </Checkbox>
                    </Form.Item>
                </div>
                <div className='ml-10 col-span-2 sm:col-span-4 lg:col-span-5'>
                    <Form.Item name="minor_surgery_check">
                        <Checkbox>Minor Surgery</Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-2 lg:col-span-1'>
                    <Form.Item name="minor_surgery_ro">
                        <Checkbox>RO </Checkbox>
                    </Form.Item>
                </div>
                <div className='ml-10 col-span-2 sm:col-span-4 lg:col-span-5'>
                    <Form.Item name="traction_check">
                        <Checkbox>Traction</Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-2 lg:col-span-1'>
                    <Form.Item name="traction_ro">
                        <Checkbox>RO </Checkbox>
                    </Form.Item>
                </div>
                <div className='ml-10 col-span-2 sm:col-span-4 lg:col-span-5'>
                    <Form.Item name="gynecology_exams_check">
                        <Checkbox>Gynecology Exams</Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-2 lg:col-span-1'>
                    <Form.Item name="gynecology_exams_ro">
                        <Checkbox>RO </Checkbox>
                    </Form.Item>
                </div>
                <div className='ml-10 col-span-2 sm:col-span-4 lg:col-span-5'>
                    <Form.Item name="functional_neurology_check">
                        <Checkbox>Functional Neurology</Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-2 lg:col-span-1'>
                    <Form.Item name="functional_neurology_ro">
                        <Checkbox>RO </Checkbox>
                    </Form.Item>
                </div>
                <div className='ml-10 col-span-2 sm:col-span-4 lg:col-span-5'>
                    <Form.Item name="mua_check">
                        <Checkbox>MUA (Manipulation under Anesthesia)</Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-2 lg:col-span-1'>
                    <Form.Item name="mua_ro">
                        <Checkbox>RO </Checkbox>
                    </Form.Item>
                </div>
                <div className='ml-10 col-span-2 sm:col-span-4 lg:col-span-5'>
                    <Form.Item name="spinal_decompression_check">
                        <Checkbox>Spinal Decompression</Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-2 lg:col-span-1'>
                    <Form.Item name="spinal_decompression_ro">
                        <Checkbox>RO </Checkbox>
                    </Form.Item>
                </div>
                <div className='ml-10 col-span-2 sm:col-span-4 lg:col-span-5'>
                    <Form.Item name="obstetrics_check">
                        <Checkbox>Obstetrics</Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-2 lg:col-span-1'>
                    <Form.Item name="obstetrics_ro">
                        <Checkbox>RO </Checkbox>
                    </Form.Item>
                </div>
                <div className='ml-10 col-span-2 sm:col-span-4 lg:col-span-5'>
                    <Form.Item name="brain_core_therapy_check">
                        <Checkbox>Brain Core Therapy</Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-2 lg:col-span-1'>
                    <Form.Item name="brain_core_therapy_ro">
                        <Checkbox>RO </Checkbox>
                    </Form.Item>
                </div>
                <div className='ml-10 col-span-2 sm:col-span-4 lg:col-span-5'>
                    <Form.Item name="vitamin_injections_check">
                        <Checkbox>Vitamin Injections </Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-2 lg:col-span-1'>
                    <Form.Item name="vitamin_injections_ro">
                        <Checkbox>RO </Checkbox>
                    </Form.Item>
                </div>
                <div className='ml-10 col-span-2 sm:col-span-4 lg:col-span-5'>
                    <Form.Item name="morphogenic_field_check">
                        <Checkbox>Morphogenic Field Technique </Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-2 lg:col-span-1'>
                    <Form.Item name="morphogenic_field_ro">
                        <Checkbox>RO </Checkbox>
                    </Form.Item>
                </div>
                <div className='ml-10 col-span-2 sm:col-span-4 lg:col-span-5'>
                    <Form.Item name="iridology_check">
                        <Checkbox>Iridology</Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-2 lg:col-span-1'>
                    <Form.Item name="iridology_ro">
                        <Checkbox>RO </Checkbox>
                    </Form.Item>
                </div>
                <div className='ml-10 col-span-2 sm:col-span-4 lg:col-span-5'>
                    <Form.Item name="other_check">
                        <Checkbox>Other (describe) </Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-2 lg:col-span-1'>
                    <Form.Item name="other_ro">
                        <Checkbox>RO </Checkbox>
                    </Form.Item>
                </div>
                <div className='ml-10 col-span-2 sm:col-span-4 lg:col-span-5'>
                    <Form.Item name="invasive_emg_check">
                        <Checkbox>Invasive EMG</Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-2 lg:col-span-1'>
                    <Form.Item name="invasive_emg_ro">
                        <Checkbox>RO </Checkbox>
                    </Form.Item>
                </div>
                <div className='ml-10 col-span-2 sm:col-span-2 lg:col-span-2'>
                    <Form.Item name="other_input">
                        <Input/>
                    </Form.Item>
                </div>
            </div>

            <div className='mt-5 grid grid-cols-2 sm:grid-cols-6 gap-2'>
                <div className='col-span-2 sm:col-span-6 lg:col-span-6'>
                    <p>2. &nbsp;&nbsp;Percentages of Patients:</p>
                </div>
                
            </div>

            <div className="flex justify-center">
                <table style={{ border: "solid 1px black", width: "60%" }}>
                    <tr className="h-12" style={{ border: "solid 1px black"}}>
                        <td className ="mt-2 ml-6" style={{ border: "solid 1px black", width: "70%" }}>
                            <div className="mt-2 ml-6 text-2sm">
                                Newborn (Birth to 12 weeks)
                            </div>
                        </td>
                        <td className="flex flex-row mt-2 items-center justify-center">
                            <div className="flex w-[30%]">
                                <Form.Item name="newborn" className="mb-0">
                                    <Input/>
                                </Form.Item>
                            </div>
                            <div className="flex text-xl">
                                %
                            </div>
                        </td>
                    </tr> 
                    <tr className="h-12" style={{ border: "solid 1px black"}}>
                        <td className ="mt-2 ml-6" style={{ border: "solid 1px black", width: "70%" }}>
                            <div className="mt-2 ml-6 text-2sm">
                                Pediatrics (12 weeks to 12 years)
                            </div>
                        </td>
                        <td className="flex flex-row mt-2 items-center justify-center">
                            <div className="flex w-[30%]">
                                <Form.Item name="pediatrics" className="mb-0">
                                    <Input/>
                                </Form.Item>
                            </div>
                            <div className="flex text-xl">
                                %
                            </div>
                        </td>
                    </tr> 
                    <tr className="h-12" style={{ border: "solid 1px black"}}>
                        <td className ="mt-2 ml-6" style={{ border: "solid 1px black", width: "70%" }}>
                            <div className="mt-2 ml-6 text-2sm">
                                Pregnant
                            </div>
                        </td>
                        <td className="flex flex-row mt-2 items-center justify-center">
                            <div className="flex w-[30%]">
                                <Form.Item name="pregnant" className="mb-0">
                                    <Input/>
                                </Form.Item>
                            </div>
                            <div className="flex text-xl">
                                %
                            </div>
                        </td>
                    </tr> 
                    <tr className="h-12" style={{ border: "solid 1px black"}}>
                        <td className ="mt-2 ml-6" style={{ border: "solid 1px black", width: "70%" }}>
                            <div className="mt-2 ml-6 text-2sm">
                                Remainder
                            </div>
                        </td>
                        <td className="flex flex-row mt-2 items-center justify-center">
                            <div className="flex w-[30%]">
                                <Form.Item name="remainder" className="mb-0">
                                    <Input/>
                                </Form.Item>
                            </div>
                            <div className="flex text-xl">
                                %
                            </div>
                        </td>
                    </tr> 
                </table>
            </div>

            <div className='mt-16 grid grid-cols-2 sm:grid-cols-6 gap-2'>
                <div className='col-span-2 sm:col-span-6'>
                    <Title level={5}>IV. UNDERWRITING INFORMATION</Title>
                </div>
            </div>    
            <div className='flex flex-col mt-2'>
                <p>
                I understand that: (1) my renewal policy is issued based upon reliance of the following representations; and,
                (2) any policy obtained by fraud, material misrepresentation or omission is null and void. 
                </p>
                <p>
                In consideration of renewal of my policy, since my ChiroFutures malpractice policy was issued last year:
                </p>
            </div>

            <div className="flex justify-center">
                <table style={{ border: "solid 1px black", width: "95%" }}>
                    <tr className="h-24" style={{ border: "solid 1px black"}}>
                        <td className ="mt-2 ml-6" style={{ border: "solid 1px black", width: "80%" }}>
                            <div className="mt-2 ml-6 text-2sm">
                                1. There have been NO changes within my practice (i.e., formed new legal entity, added a new chiropractor, changed practice tools/procedures,
                                number of hours worked, OR now sharing space with/allowing another Health Care Professional to use my office, etc.) 
                            </div>
                        </td>
                        <td className="flex flex-col text-center items-center">
                            <div className="flex justify-center mt-3 text-xs">
                                Please initial
                            </div>
                            
                            <div className="flex justify-center mt-2 text-xs w-[60%]">
                                <Form.Item
                                    name="initial1"
                                    rules={[
                                        { required: true, message: "Please enter your initials" },
                                        { max: 4, message: "Initials should be 2–4 characters" },
                                    ]}
                                    className="mb-0"
                                    >
                                    <Input
                                        maxLength={4}
                                        style={{ textTransform: "uppercase" }}
                                    />
                                </Form.Item>
                            </div>
                        </td>
                    </tr> 
                    <tr  className="h-24" style={{ border: "solid 1px black"}}>
                        <td className ="mt-2 ml-6" style={{ border: "solid 1px black", width: "80%" }}>
                            <div className="mt-2 ml-6 text-2sm">
                                2. I have had NO interaction with any Chiropractic Board other than my routine license renewal. This would include any board inquiries, complaints filed,
                                license investigations (closed, open or pending), and/or received a letter of concern/warning, stipulation, probation, and/or suspension. 
                            </div>
                        </td>
                        <td className="flex flex-col text-center items-center">
                            <div className="flex justify-center mt-3 text-xs">
                                Please initial
                            </div>
                            <div className="flex justify-center mt-2 text-xs w-[60%]">
                                <Form.Item
                                    name="initial2"
                                    rules={[
                                        { required: true, message: "Please enter your initials" },
                                        { max: 4, message: "Initials should be 2–4 characters" },
                                    ]}
                                    className="mb-0"
                                    >
                                    <Input
                                        maxLength={4}
                                        style={{ textTransform: "uppercase" }}
                                    />
                                </Form.Item>
                            </div>
                        </td>
                    </tr> 
                    <tr  className="h-24" style={{ border: "solid 1px black"}}>
                        <td className ="mt-2 ml-6" style={{ border: "solid 1px black", width: "80%" }}>
                            <div className="mt-2 ml-6 text-2sm">
                                3. I have NOT been convicted of, plead guilty or no contest to a crime (including DUI/major traffic violation), or any other violation of a law or ordinance. 
                            </div>
                        </td>
                        <td className="flex flex-col text-center items-center">
                            <div className="flex justify-center mt-3 text-xs">
                                Please initial
                            </div>
                            <div className="flex justify-center mt-2 text-xs w-[60%]">
                                <Form.Item
                                    name="initial3"
                                    rules={[
                                        { required: true, message: "Please enter your initials" },
                                        { max: 4, message: "Initials should be 2–4 characters" },
                                    ]}
                                    className="mb-0"
                                    >
                                    <Input
                                        maxLength={4}
                                        style={{ textTransform: "uppercase" }}
                                    />
                                </Form.Item>
                            </div>
                        </td>
                    </tr> 
                    <tr  className="h-24" style={{ border: "solid 1px black"}}>
                        <td className ="mt-2 ml-6" style={{ border: "solid 1px black", width: "80%" }}>
                            <div className="mt-2 ml-6 text-2sm">
                                4. Other than those previously reported, I am NOT aware of any claims, incidents, wrongful acts, licensure or accreditation actions open, closed or pending against me. 
                            </div>
                        </td>
                        <td className="flex flex-col text-center items-center">
                            <div className="flex justify-center mt-3 text-xs">
                                Please initial
                            </div>
                            <div className="flex justify-center mt-2 text-xs w-[60%]">
                                <Form.Item
                                    name="initial4"
                                    rules={[
                                        { required: true, message: "Please enter your initials" },
                                        { max: 4, message: "Initials should be 2–4 characters" },
                                    ]}
                                    className="mb-0"
                                    >
                                    <Input
                                        maxLength={4}
                                        style={{ textTransform: "uppercase" }}
                                    />
                                </Form.Item>
                            </div>
                        </td>
                    </tr> 
                </table>
            </div>

            <div className='grid grid-cols-1 gap-4 mt-4'>
                <div className='col-span-1'>
                    To the best of my knowledge and belief, the representations set forth herein are true and complete.
                    <br></br><br></br>
                    If the information supplied on this document changes between the signature date and the inception
                    date of the policy period, I will notify ChiroFutures of such a change, and I understand that
                    ChiroFutures and the insurance company may modify or decline to issue coverage. 
                </div>
                <div className='col-span-1'>
                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <Button type="primary" htmlType="submit">Submit</Button>
                </div>
                </div>
            </div>
        </Form>
      </div>
    </div>
  );
};

export default FullRenewalPage;